(function () {
  function sortVariantFieldsets(root = document) {
    const fieldsets = root.querySelectorAll(
      'variant-selects fieldset.product-form__input, variant-radios fieldset.product-form__input, fieldset.product-form__input'
    );

    fieldsets.forEach((fieldset) => {
      if (fieldset.dataset.variantSorted === 'true') return;

      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;

      const pairs = inputs
        .map((input, index) => {
          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          if (!label) return null;

          const isUnavailable =
            input.disabled ||
            input.classList.contains('disabled') ||
            label.classList.contains('disabled');

          return {
            input,
            label,
            isUnavailable,
            originalIndex: index,
          };
        })
        .filter(Boolean);

      if (!pairs.length) return;

      const available = pairs.filter((pair) => !pair.isUnavailable);
      const unavailable = pairs.filter((pair) => pair.isUnavailable);

      pairs.forEach(({ input, label }) => {
        input.remove();
        label.remove();
      });

      [...available, ...unavailable].forEach(({ input, label }) => {
        if (input.disabled || input.classList.contains('disabled')) {
          label.classList.add('is-unavailable');
        } else {
          label.classList.remove('is-unavailable');
        }

        fieldset.appendChild(input);
        fieldset.appendChild(label);
      });

      fieldset.dataset.variantSorted = 'true';
    });
  }

  function runSort(root = document) {
    requestAnimationFrame(() => {
      sortVariantFieldsets(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    runSort(document);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"], select')) {
      const container = event.target.closest('product-info, section, main') || document;
      setTimeout(() => {
        container
          .querySelectorAll('fieldset.product-form__input')
          .forEach((fieldset) => delete fieldset.dataset.variantSorted);
        runSort(container);
      }, 100);
    }
  });

  const observer = new MutationObserver((mutations) => {
    let shouldResort = false;

    for (const mutation of mutations) {
      if (mutation.type !== 'childList' || !mutation.addedNodes.length) continue;

      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (
          node.matches?.('variant-selects, variant-radios, product-info') ||
          node.querySelector?.('variant-selects, variant-radios, fieldset.product-form__input')
        ) {
          shouldResort = true;
        }
      });
    }

    if (shouldResort) {
      document
        .querySelectorAll('fieldset.product-form__input')
        .forEach((fieldset) => delete fieldset.dataset.variantSorted);
      runSort(document);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();